// src/components/KeyboardDismisser.tsx
import React, { useEffect } from 'react';

import { logger } from "utils/logger";
const KeyboardDismisser: React.FC = () => {
  useEffect(() => {
    const handleOutsideClick = (event: MouseEvent) => {
      const target = event.target as HTMLElement;
      const isFormField =
        target.tagName === 'INPUT' ||
        target.tagName === 'TEXTAREA' ||
        target.tagName === 'SELECT';

      if (!isFormField) {
        if (document.activeElement instanceof HTMLElement) {
          document.activeElement.blur();
        }
        try {
          if (
            window.Telegram?.WebApp &&
            typeof (window.Telegram.WebApp as any).hideKeyboard === 'function'
          ) {
            (window.Telegram.WebApp as any).hideKeyboard();
          }
        } catch (err) {
          logger.debug('Telegram API call failed', { error: err });
        }
      }
    };

    document.addEventListener('click', handleOutsideClick);
    return () => {
      document.removeEventListener('click', handleOutsideClick);
    };
  }, []);

  return null;
};

export default KeyboardDismisser;
